import * as $ from 'jquery';
import 'slick-carousel';
//@ts-ignore
var Modal = require('../lib/Modal.js');
//@ts-ignore
var ScrollSpy = require('./ScrollSpy.js');

const Anniversary = () => {
	if (!document.querySelector('.__anniversary')) {
		return;
	}

	// VIDEO MODAL
	const modal = new Modal('video', {iframe: true,fullscreen: true});
	
	$('.slide__playBtn').on('click', function(event) {
		event.preventDefault();
		modal.open({href: this.getAttribute('href')});
	});

	// SCROLL TO LEARN MORE ARROW
	document.querySelector('.slide__arrow').addEventListener('click', function(event) { 
		event.preventDefault();
		const selector = this.href.substring(this.href.indexOf('#') + 1);
		document.getElementById(selector).scrollIntoView();
	});

	// NAV
	var scrollSpy = new ScrollSpy({
		trigger: 'slide',
		heading: 'anniversaryNav li',
		activeClass: 'active',
		percentInView: 50
	});

	function activateHeadingHandlers() {
		$('.anniversaryNav a').on('click.scrollTo', function(event) {
			event.preventDefault();
			var triggerIndex = $(this).parent().index();
			var selectedGroup = $('.slide').filter(function(index, element) {
				return index === triggerIndex;
			});

			// ANIMATE SCROLL TO SELECTED GROUP
			// Temporarily turn off changing the class of the active item on the left
			scrollSpy.setEnabled(false);

			$('html, body').animate({
				scrollTop: selectedGroup.offset().top},
				'fast',
				function() {
					// Now that the animation is done re-enable switching what is selected on left
					scrollSpy.setEnabled(true);
				}
			);

			// Could replace the "animate" above when IE 11 is dropped (scrollTo isn't supported).
			/**
			 * Native scrollTo with callback
			 * @param offset - offset to scroll to
			 * @param callback - callback function
			 */
			//@ts-ignore
			/* function scrollTo(offset, callback) {
				const fixedOffset = offset.toFixed(),
					onScroll = function () { console.log(window.pageYOffset.toFixed(), fixedOffset, '***');
						if (window.pageYOffset.toFixed() === fixedOffset) {
							window.removeEventListener('scroll', onScroll)
							callback()
						}
					}

				window.addEventListener('scroll', onScroll)
				onScroll()
				window.scrollTo({top: offset})
			} 
			scrollTo(selectedGroup.offset().top, function() { 
				// Now that the animation is done re-enable switching what is selected on left
				scrollSpy.setEnabled(true);
			}); */
		});
	}

	scrollSpy.activate();
	activateHeadingHandlers();

	// GALLERIES
	const activeClass = 'custom-slick-active',
		activeTransitionClass = 'custom-slick-active-transition',
		ariaAttribute = 'aria-hidden';
			
	$('.anniversaryCarousel__inner').each(function(index) {
		$(this).slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 5000,
			arrows: false,
			dots: true,
			pauseOnFocus: false,
			pauseOnHover: false,
			pauseOnDotsHover: false,
			fade: true,
			appendDots: $('.anniversaryCarousel__nav', this),
			customPaging: (slider: any, i: number) => {
				const dotHeading = slider.$slides.eq(i).find('.anniversaryCarousel__slide').data('label');
				return '<button type="button" class="slickDot">' + dotHeading + '</button>';
			},
		}).on( 'init', function() {
			$( '.slick-dots li:first-of-type' ).addClass( activeClass ).attr( ariaAttribute, 'false' );
		}).on( 'beforeChange', function( event, slick, currentSlide, nextSlide ) {
			// Active classes break when dots are appended to each slide. Fix per https://github.com/kenwheeler/slick/issues/974
			$( 'li', slick.$dots ).removeClass( activeClass ).attr( ariaAttribute, 'true' );
			slick.$dots.each( function() {
				$( 'li', $( this ) ).eq( currentSlide ).addClass( activeTransitionClass );

				$( 'li', $( this ) ).eq( nextSlide ).addClass( activeClass ).attr( ariaAttribute, 'false' );
			} );
		}).on( 'afterChange', function( event, slick, currentSlide ) {
			$( 'li', slick.$dots ).removeClass( activeTransitionClass );
		} );
	});
};

export default Anniversary;